"use strict";
/**
 * Copyright (c) Haiku 2016-2018. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable-next-line:variable-name
var EventsDict = {};
var eventsList = [
    'onAbort',
    'onAnimationEnd',
    'onAnimationIteration',
    'onAnimationStart',
    'onBlur',
    'onCanPlay',
    'onCanPlayThrough',
    'onChange',
    'onClick',
    'onCompositionEnd',
    'onCompositionStart',
    'onCompositionUpdate',
    'onContextMenu',
    'onCopy',
    'onCut',
    'onDoubleClick',
    'onDrag',
    'onDragEnd',
    'onDragEnter',
    'onDragExit',
    'onDragLeave',
    'onDragOver',
    'onDragStart',
    'onDrop',
    'onDurationChange',
    'onEmptied',
    'onEncrypted',
    'onEnded',
    'onError',
    'onFocus',
    'onInput',
    'onKeyDown',
    'onKeyPress',
    'onKeyUp',
    'onLoad',
    'onLoadedData',
    'onLoadedMetadata',
    'onLoadStart',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp',
    'onPaste',
    'onPause',
    'onPlay',
    'onPlaying',
    'onProgress',
    'onRateChange',
    'onScroll',
    'onSeeked',
    'onSeeking',
    'onSelect',
    'onStalled',
    'onSubmit',
    'onSuspend',
    'onTimeUpdate',
    'onTouchCancel',
    'onTouchEnd',
    'onTouchMove',
    'onTouchStart',
    'onTransitionEnd',
    'onVolumeChange',
    'onWaiting',
    'onWheel',
];
for (var i = 0; i < eventsList.length; i++) {
    var name_1 = eventsList[i];
    EventsDict[name_1] = 'func';
    EventsDict[name_1 + 'Capture'] = 'func';
}
exports.default = EventsDict;
//# sourceMappingURL=EventsDict.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/core/lib/adapters/react-dom/EventsDict.js
// module id = 101
// module chunks = 35783957827783 127651196306611 162898551421021